import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { getTiltPositionOptions } from '../../../helpers/tiltPosition';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  tiltPosition: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (tiltPosition, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      tiltPosition,
    },
  });
};

export const TiltPosition = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { tiltPosition },
  } = state.context;
  const tiltPositionOptions = getTiltPositionOptions(state.context);
  const productType = getBaseProductType(state.context);

  if (
    isCurrentState('tiltPosition', state) &&
    tiltPositionOptions.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Tilt Position</Heading>
      <Selector isSlider={true}>
        {tiltPositionOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'tiltPosition',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === tiltPosition}
              onClick={onClick(option, send)}
              key={option}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
